<template>
    <div>
        <div v-if="goal1shown">
            <div class="caption font-weight-bold mb-1">Goal #1: {{ goal1category }}</div>
            <p>{{ goal1text }}</p>
        </div>
        <div v-if="goal2shown">
            <div class="caption font-weight-bold mb-1">Goal #2: {{ goal2category }}</div>
            <p>{{ goal2text }}</p>
        </div>
        <div v-if="goal3shown">
            <div class="caption font-weight-bold mb-1">Goal #3: {{ goal3category }}</div>
            <p>{{ goal3text }}</p>
        </div>
        <div v-if="goal4shown">
            <div class="caption font-weight-bold mb-1">Goal #4: {{ goal4category }}</div>
            <p>{{ goal4text }}</p>
        </div>
    </div>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        goal1category: get('section4/myGoals@1.category'),
        goal1text: get('section4/myGoals@1.text'),
        goal1shown: get('section4/myGoals@1.shown'),
        goal2category: get('section4/myGoals@2.category'),
        goal2text: get('section4/myGoals@2.text'),
        goal2shown: get('section4/myGoals@2.shown'),
        goal3category: get('section4/myGoals@3.category'),
        goal3text: get('section4/myGoals@3.text'),
        goal3shown: get('section4/myGoals@3.shown'),
        goal4category: get('section4/myGoals@4.category'),
        goal4text: get('section4/myGoals@4.text'),
        goal4shown: get('section4/myGoals@4.shown')
    }
};
</script>
